import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    name: '字段描述',
    type: 'BDRULE_DF',
}
